/**
 * Login Module
 */
(function () {
	angular.module('app.login', []);
})();